import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, setDoc, collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendEmailVerification,
  onAuthStateChanged 
} from "firebase/auth";
import { useNavigate, Navigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";


function Login() {
  const [checkingAuth,
    setCheckingAuth] =
    useState(true);
    
    const [currentUser,
    setCurrentUser] =
    useState(null);
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [peso, setPeso] = useState("");
  const [altura, setAltura] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [dni, setDni] = useState("");
const [telefono, setTelefono] = useState("");
const [genero, setGenero] = useState("");

const [deferredPrompt, setDeferredPrompt] = useState(null);
const isAndroid =
  /android/i.test(
    navigator.userAgent
  );

const isStandalone =
  window.matchMedia(
    "(display-mode: standalone)"
  ).matches ||
  window.navigator.standalone;

  const [canInstall, setCanInstall] =
  useState(false);

const [mostrarGuiaIOS, setMostrarGuiaIOS] =
  useState(false);


const [loginDni, setLoginDni] = useState("");
// "email" o "dni"

  // 🚨 Estados para errores
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const navigate = useNavigate();

  const functions = getFunctions();

  const buscarEmailPorDni = httpsCallable(
    functions,
    "buscarEmailPorDni"
  );

  // Estilos reutilizables
const inputStyle = (error) => ({
  width: "100%",
  padding: "8px",
  fontSize: "14px",
  borderRadius: "6px",
  border: error ? "1px solid red" : "1px solid #ccc",
  boxSizing: "border-box",
});

const eyeButtonStyle = {
  position: "absolute",
  right: "5px",
  top: "50%",
  transform: "translateY(-50%)",
  width: "30px",
  height: "30px",
  border: "none",
  borderRadius: "4px",
  background: "white",
  cursor: "pointer",
  fontSize: "16px",
};

const primaryButtonStyle = {
  width: "100%",
  padding: "10px",
  fontSize: "14px",
  backgroundColor: "#4a90e2",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const secondaryButtonStyle = {
  marginTop: "10px",
  backgroundColor: "transparent",
  color: "#4a90e2",
  border: "1px solid #4a90e2",
  borderRadius: "6px",
  padding: "8px 10px",
  cursor: "pointer",
  fontSize: "13px",
};

const ErrorMessage = ({ message }) => (
  <div style={{ color: "red", fontSize: "12px", width: "100%", textAlign: "left" }}>
    {message}
  </div>
);

const inputWrapper = {
  position: "relative",
  width: "100%",
};

const inputWithUnit = {
  ...inputStyle(),
  paddingRight: "50px",
};

const unitLabel = {
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "13px",
  fontWeight: "600",
  color: "#64748b",
  pointerEvents: "none",
};




  // Validación en tiempo real
  useEffect(() => {
    if (confirmEmail && confirmEmail !== email) {
      setEmailError("Los emails no coinciden");
    } else {
      setEmailError("");
    }

    if (confirmPassword && confirmPassword !== password) {
      setPasswordError("Las contraseñas no coinciden");
    } else {
      setPasswordError("");
    }
  }, [email, confirmEmail, password, confirmPassword]);

  useEffect(() => {
    const unsubscribe =
      onAuthStateChanged(
        auth,
        (user) => {
          setCurrentUser(user);
          setCheckingAuth(false);
        }
      );
  
    return () => unsubscribe();
  }, []);


  useEffect(() => {
    const isIOS =
      /iphone|ipad|ipod/i.test(
        navigator.userAgent
      );
  
    const isStandalone =
      window.navigator.standalone;
  
    if (isIOS && !isStandalone) {
      setMostrarGuiaIOS(true);
    }
  }, []);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
  
      setDeferredPrompt(e);
      setCanInstall(true);
    };
  
    window.addEventListener(
      "beforeinstallprompt",
      handler
    );

   
  
    return () =>
      window.removeEventListener(
        "beforeinstallprompt",
        handler
      );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      if (isRegister) {

        const partes = fechaNacimiento.split("/");

if (partes.length !== 3) {
  alert("Ingresá una fecha válida (DD/MM/AAAA)");
  return;
}

const dia = parseInt(partes[0], 10);
const mes = parseInt(partes[1], 10);
const anio = parseInt(partes[2], 10);

const fecha = new Date(anio, mes - 1, dia);

// validar fecha real
if (
  fecha.getFullYear() !== anio ||
  fecha.getMonth() !== mes - 1 ||
  fecha.getDate() !== dia
) {
  alert("Fecha de nacimiento no válida");
  return;
}

const hoy = new Date();

let edad = hoy.getFullYear() - anio;

const m = hoy.getMonth() - (mes - 1);

if (m < 0 || (m === 0 && hoy.getDate() < dia)) {
  edad--;
}

// 🔥 REGLA: solo 15 a 99 años
if (edad < 15 || edad > 99) {
  alert("Debes tener entre 15 y 99 años para registrarte");
  return;
}

        
        // Validaciones de registro
        if (email !== confirmEmail) {
          setEmailError("Los emails no coinciden");
          return;
        }
        if (password !== confirmPassword) {
          setPasswordError("Las contraseñas no coinciden");
          return;
        }
        
        const dniLimpio = dni.replace(/\D/g, "").trim();

        try {
          const q = query(
            collection(db, "users"),
            where("dni", "==", dniLimpio)
          );
        
          const snapshot = await getDocs(q);
        
          if (!snapshot.empty) {
            alert("Este DNI ya está registrado");
            return;
          }
        
        } catch (error) {
          console.error(error);
          alert("Error validando DNI");
          return;
        }

if (!nombre.trim()) {
  alert("Ingresá tu nombre");
  return;
}

if (!apellido.trim()) {
  alert("Ingresá tu apellido");
  return;
}

if (!dni.trim()) {
  alert("Ingresá tu DNI");
  return;
}

if (!telefono.trim()) {
  alert("Ingresá tu teléfono");
  return;
}



if (!peso) {
  alert("Ingresá tu peso");
  return;
}

if (!altura) {
  alert("Ingresá tu altura");
  return;
}

if (!genero) {
  alert("Seleccioná un género");
  return;
}

        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
  
        await sendEmailVerification(user);

localStorage.setItem(
  "registroPendiente",
  JSON.stringify({
    nombre,
    apellido,
    dni,
    telefono,
    fechaNacimiento: `${dia}/${mes}/${anio}`, // 👈 FIX REAL
    peso,
    altura,
    genero
  })
);

navigate("/verificar-email");
return;

        
        // 🔔 NOTIFICACIÓN A LA NUTRICIONISTA
        await addDoc(collection(db, "notificaciones"), {
          type: "nuevo_paciente",
          pacienteId: user.uid,
          nombre,
          apellido,
          dni,
          telefono,
          email: user.email,
          fecha: new Date()
        });
        navigate("/verificar-email");
      } else {
        

        
       // Login solo DNI
let emailFinal = "";

const functions = getFunctions();

const buscarEmailPorDni =
  httpsCallable(
    functions,
    "buscarEmailPorDni"
  );

const res = await buscarEmailPorDni({
  dni: loginDni.trim()
});

if (!res.data?.email) {
  alert("DNI no encontrado");
  return;
}

emailFinal = res.data.email?.trim();

if (!emailFinal) {
  alert("No hay email asociado");
  return;
}

const userCredential = await signInWithEmailAndPassword(
  auth,
  emailFinal,
  password
);

const user = userCredential.user;

if (!user.emailVerified) {
  alert("Debes verificar tu email antes de ingresar");
  return;
}

navigate("/dashboard");

              }
            } catch (error) {
              alert(error.message);
            }
          };


// 👇 PEGAR ACÁ
if (checkingAuth) {
  return null;
}

if (currentUser) {
  return currentUser.emailVerified
    ? (
        <Navigate
          to="/dashboard"
          replace
        />
      )
    : (
        <Navigate
          to="/verificar-email"
          replace
        />
      );
}


const recuperarPassword = async () => {
  try {
    const res = await buscarEmailPorDni({
      dni: loginDni.trim()
    });
    
    const email = res.data.email;
    
    await sendPasswordResetEmail(auth, email);

    alert(
      "Te enviamos un correo para recuperar contraseña"
    );
  } catch (error) {
    alert(error.message);
  }
};

  const instalarApp = async () => {
    if (!deferredPrompt) return;
  
    deferredPrompt.prompt();
  
    const choice =
      await deferredPrompt.userChoice;
  
      if (choice.outcome === "accepted") {
        alert(
          "✅ RNutricion instalada.\n\nLa encontrarás en tu pantalla de inicio o lista de apps."
        );
      }
  
    setDeferredPrompt(null);
    setCanInstall(false);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "50px",
        fontFamily: "Arial, sans-serif",
      }}
    >
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "20px"
  }}
>
  <img
    src="logo512sinfondo.png"
    alt="logo"
    style={{
      width: "100px",
      height: "100px",
      objectFit: "cover",
      borderRadius: "8px"
    }}
  />

  <h1 style={{ margin: 0, fontSize: "24px" }}>
    {isRegister ? "Registro" : "RNutricion"}
  </h1>

  
</div>  
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "12px",
          width: "250px",
        }}
      >
        {/* Email */}
       
        {isRegister ? (
  <>
    {/* Email registro */}
    <input
      type="email"
      placeholder="Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      style={inputStyle(emailError)}
    />

    <input
      type="email"
      placeholder="Repetir Email"
      value={confirmEmail}
      onChange={(e) => setConfirmEmail(e.target.value)}
      style={inputStyle(emailError)}
    />

    {emailError && <ErrorMessage message={emailError} />}
  </>
) : (
  <>
    {/* Login */}
    <input
      type="text"
      placeholder="DNI"
      value={loginDni}
      onChange={(e) =>
        setLoginDni(e.target.value.replace(/\D/g, "").slice(0, 8))
      }
      style={inputStyle()}
    />
  </>
)}
  
        {/* Contraseña con botón ojo al costado */}
        <div style={{ position: "relative", width: "100%" }}>
          <script src="https://kit.fontawesome.com/a076d05399.js" crossorigin="anonymous"></script>

          <input
            type={showPasswords ? "text" : "password"}
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              ...inputStyle(passwordError),
              paddingRight: "40px",
            }}
          />
          <button
            type="button"
            onClick={() => setShowPasswords(!showPasswords)}
            style={eyeButtonStyle}
          >
            {showPasswords ? "x" : "◎"}
          </button>
        </div>
  
        {isRegister && (
          <input
            type={showPasswords ? "text" : "password"}
            placeholder="Repetir Contraseña"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={inputStyle(passwordError)}
          />
        )}
        {passwordError && <ErrorMessage message={passwordError} />}
  
        {/* Datos personales */}
{isRegister && (
  <>
    <input
      type="text"
      placeholder="Nombre"
      value={nombre}
      onChange={(e) => setNombre(e.target.value)}
      style={inputStyle()}
    />

    <input
      type="text"
      placeholder="Apellido"
      value={apellido}
      onChange={(e) => setApellido(e.target.value)}
      style={inputStyle()}
    />

    <input
      type="text"
      inputMode="numeric"
      placeholder="DNI"
      value={dni}
      onChange={(e) =>
        setDni(e.target.value.replace(/\D/g, "").slice(0, 8))
      }
      style={inputStyle()}
    />

<select
  value={genero}
  onChange={(e) => setGenero(e.target.value)}
  style={inputStyle()}
>
  <option value="">Seleccionar género</option>
  <option value="hombre">Hombre</option>
  <option value="mujer">Mujer</option>
  
</select>

<input
  type="text"
  inputMode="numeric"
  placeholder="Fecha Nacimiento DD/MM/AAAA"
  value={fechaNacimiento}
  maxLength={10}
  onChange={(e) => {
    let v = e.target.value.replace(/\D/g, "");

    if (v.length > 8) v = v.slice(0,8);

    if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
    if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);

    setFechaNacimiento(v);
  }}
  style={inputStyle()}
/>

    {/* ================= PESO ================= */}

<div style={inputWrapper}>
  <input
    type="number"
    placeholder="Peso"
    value={peso}
    min="40"
    max="300"
    onChange={(e) => setPeso(e.target.value)}
    style={inputWithUnit}
  />
  <span style={unitLabel}>kg</span>
</div>

{/* ================= ALTURA ================= */}

<div style={inputWrapper}>
  <input
    type="number"
    placeholder="Altura"
    value={altura}
    min="140"
    max="230"
    onChange={(e) => setAltura(e.target.value)}
    style={inputWithUnit}
  />
  <span style={unitLabel}>cm</span>
</div>

    <input
      type="text"
      inputMode="numeric"
      placeholder="CELULAR 10 DIGITOS"
      value={telefono}
      onChange={(e) =>
        setTelefono(e.target.value.replace(/\D/g, "").slice(0, 10))
      }
      style={inputStyle()}
    />
  </>
)}
  
        {/* Botón principal */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          
  


</div>
        <button
          type="submit"
          disabled={emailError || passwordError}
          style={primaryButtonStyle}
        >
          {isRegister ? "Registrarse" : "Ingresar"}
        </button>
      </form>
  
      {/* Botón secundario */}
      <button
        onClick={() => setIsRegister(!isRegister)}
        style={secondaryButtonStyle}
      >
        {isRegister ? "¿Ya tienes cuenta? Inicia sesión" : "¿No tienes cuenta? Regístrate"}
      </button>

      <button
  type="button"
  onClick={recuperarPassword}
  style={{
    marginTop: "10px",
    border: "none",
    background: "transparent",
    color: "#2563eb",
    cursor: "pointer",
    fontSize: "13px"
  }}
>
  ¿Olvidaste tu contraseña?
</button>



{/* FOOTER */}
<div
  style={{
    width: "100%",
    marginTop: "30px",
    padding: "18px 10px",

    textAlign: "center",

    fontSize: "12px",
    color: "#64748b",

    borderTop: "1px solid rgba(255,255,255,0.06)",

    letterSpacing: "0.3px"
  }}
>
  © {new Date().getFullYear()} RNutricion · Todos los derechos reservados
  <br />

  <span style={{ fontSize: "11px", opacity: 0.7 }}>
    Desarrollado por RNutricion
  </span>

  <br />

  <a
    href="mailto:contacto@ronutricion.com"
    style={{
      fontSize: "11px",
      color: "#3b82f6",
      textDecoration: "none",
      fontWeight: "600"
    }}
  >
    contacto@ronutricion.com
  </a>
</div>

{canInstall &&
 isAndroid &&
 !isStandalone && (
  <button
    onClick={instalarApp}
    style={{
      background:
        "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "10px 16px",
      fontSize: "15px",
      fontWeight: 600,
      cursor: "pointer",
      marginBottom: "16px",
      boxShadow:
        "0 4px 12px rgba(59,130,246,0.35)"
    }}
  >
    Instalar App en Android 📲
  </button>
)}



{mostrarGuiaIOS && (
 <button
 onClick={() => {
   const confirmar =
     window.confirm(
       "📲 IMPORTANTE\n\nLee la guía y luego vuelve a ronutricion.com para instalar la app desde Safari.\n\nNo hagas 'Agregar a pantalla de inicio' desde el PDF."
     );

   if (confirmar) {
     window.location.href =
       "/guia-ios.pdf";
   }
 }}
 style={{
   background: "#1e293b",
   color: "white",
   border: "none",
   borderRadius: "10px",
   padding: "10px 16px",
   fontSize: "15px",
   fontWeight: 600,
   cursor: "pointer",
   marginBottom: "16px"
 }}
>
 Instalar App en iPhone 
</button>
)}



    </div>




    



  );

  

  
  
 
}

export default Login;